import dayjs, { Dayjs } from "dayjs";

/**
 * Validates if start date is after end date
 * @param startDate - Start date (can be string, Date, Dayjs, or null)
 * @param endDate - End date (can be string, Date, Dayjs, or null)
 * @returns true if dates are invalid (start > end), false otherwise
 */
export const areDatesInvalid = (
    startDate: string | Date | Dayjs | null | undefined,
    endDate: string | Date | Dayjs | null | undefined
): boolean => {
    if (!startDate || !endDate) {
        return false;
    }
    const start = new Date(startDate as any);
    const end = new Date(endDate as any);
    return start > end;
};

/**
 * Formats a date for localStorage persistence
 * @param date - Date to format (can be string, Date, Dayjs, or null)
 * @returns Formatted date string (MM/DD/YYYY) or null
 */
export const formatDateForStorage = (
    date: string | Date | Dayjs | null | undefined
): string | null => {
    if (!date) {
        return null;
    }
    const dayjsDate = dayjs(date);
    if (!dayjsDate.isValid()) {
        return null;
    }
    return dayjsDate.format("MM/DD/YYYY");
};

/**
 * Parses a date from localStorage format
 * @param dateString - Date string in MM/DD/YYYY format
 * @returns Dayjs object or null if invalid
 */
export const parseDateFromStorage = (dateString: string | null | undefined): Dayjs | null => {
    if (!dateString) {
        return null;
    }
    const parsed = dayjs(dateString, "MM/DD/YYYY");
    return parsed.isValid() ? parsed : null;
};

